import { throttle } from 'lodash-es';
import { RefCallback, useMemo, useState } from 'react';
import useResizeObserver from 'use-resize-observer';

import { SIXTY_FPS } from '../constants.js';

/** @internal */
export interface SizeState {
  height?: number;
  width?: number;
}

/** @internal */
export interface _ResizePayload extends SizeState {
  refCallback: RefCallback<HTMLElement | null>;
}

/**
 * Trigger size event only every `wait` ms.
 * Returns the refCallback for the component that you want to observe
 *
 * @returns ResizePayload
 * @param wait - amount of milliseconds to throttle the resizing callback
 * @internal
 */
export function useThrottledResizeObserver(
  wait: number = SIXTY_FPS,
): _ResizePayload {
  const [size, setSize] = useState<SizeState>({});
  const onResize = useMemo(() => throttle(setSize, wait), [wait]);

  const { ref } = useResizeObserver<HTMLElement>({ onResize });

  return { refCallback: ref, ...size };
}
